import axios from "axios";

export const getAllPelanggan = async () => {
  return await axios.get(`${window._HOST}admin/pelanggans/`, {
    withCredentials: true,
  });
};

export const getAllDetailPelanggan = async () => {
  return await axios.get(`${window._HOST}admin/pelanggans/detail`, {
    withCredentials: true,
  });
};

export const getAllDataTablePelanggan = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/pelanggans/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/pelanggans/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertNewPelanggan = async (formData) => {
  return await axios.post(`${window._HOST}admin/pelanggans/`, formData, {
    withCredentials: true,
  });
};

export const updatePelanggan = async (formData, id) => {
  return await axios.put(`${window._HOST}admin/pelanggans/${id}`, formData, {
    withCredentials: true,
  });
};

export const deletePelanggan = async (id) => {
  return await axios.delete(`${window._HOST}admin/pelanggans/${id}`, {
    withCredentials: true,
  });
};

export const getDropdownPelanggan = async () => {
  return await axios.get(`${window._HOST}admin/pelanggans/dropdown`, {
    withCredentials: true,
  });
};
